// extracted by mini-css-extract-plugin
module.exports = {"root":"DataViewHeaderAction_root__OuNzO","isDisabled":"DataViewHeaderAction_isDisabled__c-DzH"};